<template>
  <div class="navs">
     <router-link to="/homepage">HOME</router-link>
     <router-link to="/garment">GARMENT</router-link>
     <router-link to="/fabric">FABRIC</router-link>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  created () {
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.navs a {
  color: #000000;
  text-decoration: none;
  font-size: 20px;
  margin: 0 20px;
  line-height: 80px;
}
.router-link-active {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue